import * as tslib_1 from "tslib";
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import * as actions from './actions';
import { PostsStoreService } from './store.service';
import { PostsService } from '@stop-counter/shared/services';
export class Effects {
    constructor(api, actions$, self) {
        this.api = api;
        this.actions$ = actions$;
        this.self = self;
        this.loadAction$ = this.actions$.pipe(ofType(actions.Actions.LOAD), map(action => action.payload), switchMap((type) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.api
                .getPosts(type)
                .then(res => new actions.LoadSuccessAction(res))
                .catch(error => this.handleError(error));
        })));
        this.loadSingleAction$ = this.actions$.pipe(ofType(actions.Actions.LOAD_SINGLE), map(action => action.payload), switchMap((slug) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.api
                .getPost(slug)
                .then(res => new actions.LoadSuccessAction([res]))
                .catch(error => this.handleError(error));
        })));
    }
    handleError(error) {
        return new actions.ErrorAction(error);
    }
}
tslib_1.__decorate([
    Effect(),
    tslib_1.__metadata("design:type", Object)
], Effects.prototype, "loadAction$", void 0);
tslib_1.__decorate([
    Effect(),
    tslib_1.__metadata("design:type", Object)
], Effects.prototype, "loadSingleAction$", void 0);
